import { ActiveTab, BulkAction, Pagination, Search } from "@saleor/types";

export const auditLogsSection = "/logs/";
export const auditLogsLocationRate = auditLogsSection + "location-rate/";
export const auditLogsPriceRate = auditLogsSection + "price-rate/";
export const auditLogsExpressFleet = auditLogsSection + "express-fleet/";

export type AuditLogsUrlQueryParams = BulkAction &
  ActiveTab &
  Pagination & {
    mall?: string;
  } & Search;
